export const defaultCurrentPage = 0;
export const defaultItemsPerPage = 100;
export const newsItemsPerPage = 6;
export const itemsPerPageOptions = [100, 200, 300];

export const DEFAULT_TABLE_QUERY = {
    currentPage: defaultCurrentPage,
    itemsPerPage: defaultItemsPerPage,
};

export const ACCESS = {
    All: ['admin', 'sysop', 'support', 'content-manager'],
    AdminSysop: ['admin', 'sysop'],
    SysopManager: ['sysop', 'content-manager'],
    AdminSysopManager: ['admin', 'sysop', 'content-manager'],
    AdminSysopSupport: ['admin', 'sysop', 'support'],
    Sysop: ['sysop'],
};

export const versionsFrontend = ['Nevada', 'Lemon', 'New-Nevada'];

export const playerTypeFiles = ['confirmationId', 'selfieAndId', 'paymentMethod'];

export const bonusStatuses = ['new', 'active', 'canceled', 'completed', 'expired'];

export const ACTIONS_LIST = ['bet', 'win', 'refund'];
